export default __webpack_public_path__ + "static/media/prbicon_AdminCenter.8482197c.svg";